import PropTypes from "prop-types";
import React, { Component } from "react";
import { SketchPicker } from "react-color";
import { connect } from "react-redux";
import TldrBrandkitColors from "../../common/TldrBrandkitColors";
import {
  StyledAdvEditorToolbarFormatGroup,
  StyledAdvEditorToolbarRow,
  StyledShapeColorsContainer,
} from "../../styled/details/stylesDetails";
import { DEFAULT_COLOR_PRESETS, FABRIC_SVG_ELEMENT } from "../constants";
import EyeDropperContainer from "../../common/tldrColorPicker/EyeDropperContainer";
import { Menu, MenuButton, Button, MenuList } from "@chakra-ui/react";
import { isColor } from "../../../_utils/common";
import { withTranslation } from "react-i18next";

const menuButtonStyles = (color) => {
  return {
    _hover: {
      backgroundColor: color,
    },
    _active: {
      backgroundColor: color,
      border: "2px solid",
      borderColor: "primary.200",
    },
    _focus: {
      backgroundColor: color,
    },
    backgroundColor: color,
    borderRadius: "0.5rem",
    margin: "0 0.5rem 0.5rem 0",
  };
};
class IconCommonActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fillColor: "",
      selectedColor: "",
      showFillColorPopup: false,
      index: 0,
    };
  }

  render() {
    const { activeElement, brandKit, bottom, right, t } = this.props;
    const { showFillColorPopup, fillColor, selectedColor } = this.state;
    const canvas = this.props.canvasRef.handler.canvas;

    const { palette } =
      brandKit.brandkitPayload.length > 0 && brandKit.brandkitPayload[0];
    let elementFormat = activeElement.format;

    let circleColors = [];
    palette?.length > 0 &&
      palette[0].colors.forEach((color, index) => {
        if (color.rgb) circleColors.push(color.rgb);
      });

    let colorElement;
    if (elementFormat.type === FABRIC_SVG_ELEMENT) {
      let fillMapping = elementFormat?.fillMapping || [];

      colorElement = fillMapping.map((fillMap, index) => (
        <Menu
          placement={this.props.isMobileView ? "top" : "auto"}
          isLazy
          key={index}
        >
          <MenuButton
            as={Button}
            onClick={() => this.toggleFillColorPopup(fillMap, index)}
            sx={menuButtonStyles(
              isColor(fillMap?.replaceFill)
                ? fillMap?.replaceFill
                : "transparent"
            )}
            size="sm"
          />
          <MenuList
            py={this.props.isMobileView ? "0" : ""}
          >
            {brandKit.brandkitPayload.length > 0 && (
              <TldrBrandkitColors
                handleOnChangeComplete={({ rgb, hex }) =>
                  this.onChangeCompleteSelectedShapeColorHandler({ rgb, hex })
                }
              />
            )}
            <EyeDropperContainer
              canvas={canvas}
              iconContainerStyle={{ transform: "translate(9px, 165px)" }}
              onChange={this.onChangeCompleteSelectedShapeColorHandler}
            />
            <SketchPicker
              disableAlpha={true}
              presetColors={DEFAULT_COLOR_PRESETS}
              color={fillColor}
              onChange={this.onChangeCompleteSelectedShapeColorHandler}
            />
          </MenuList>
        </Menu>
      ));
    } else {
      colorElement = (
        <Menu isLazy placement={this.props.isMobileView ? "top" : "auto"}>
          <MenuButton
            as={Button}
            onClick={() => this.toggleFillColorPopup(elementFormat.fill)}
            sx={menuButtonStyles(elementFormat.fill)}
            size="sm"
          />

          <MenuList
            py={this.props.isMobileView ? "0" : ""}
          >
            {brandKit.brandkitPayload.length > 0 && (
              <TldrBrandkitColors
                handleOnChangeComplete={({ rgb, hex }) =>
                  this.onChangeCompleteSelectedShapeColorHandler({ rgb, hex })
                }
              />
            )}
            <EyeDropperContainer
              canvas={canvas}
              iconContainerStyle={{ transform: "translate(9px, 165px)" }}
              onChange={this.onChangeCompleteSelectedShapeColorHandler}
            />
            <SketchPicker
              disableAlpha={true}
              presetColors={DEFAULT_COLOR_PRESETS}
              color={fillColor}
              onChange={this.onChangeCompleteSelectedShapeColorHandler}
            />
          </MenuList>
        </Menu>
      );
    }

    return (
      <StyledAdvEditorToolbarRow>
        <StyledAdvEditorToolbarFormatGroup>
          <div className="title">{t("fonts.colors")}</div>
          <StyledShapeColorsContainer>
            {colorElement}
          </StyledShapeColorsContainer>
        </StyledAdvEditorToolbarFormatGroup>
      </StyledAdvEditorToolbarRow>
    );
  }

  toggleFillColorPopup = (color, index) => {
    const { showFillColorPopup, activeIndex } = this.state;

    this.setState({
      ...this.state,
      selectedColor: color,
      activeIndex: index,
      fillColor: color?.replaceFill || color,
      showFillColorPopup: activeIndex !== index || !showFillColorPopup,
    });
  };

  closeColorPicker = () => {
    this.setState({
      ...this.state,
      showFillColorPopup: false,
    });
  };

  onChangeCompleteSelectedShapeColorHandler = ({ hex, rgb }) => {
    if (this.state.fillColor === hex) return;

    const { activeElement } = this.props;
    this.setState({ fillColor: hex }, () => {
      if (activeElement.format.type === FABRIC_SVG_ELEMENT) {
        this.changeSelectedIconColor(hex);
      } else {
        this.changeFillColor(rgb);
      }
    });
  };

  changeFillColor = (rgb) => {
    const rgba = `rgba(${rgb.r},${rgb.g},${rgb.b},${rgb.a})`;
    const activeObject = this.props.canvasRef.handler.canvas.getActiveObject();
    if (activeObject) {
      activeObject.set("fill", rgba);
      this.props.canvasRef.handler.set("objects", activeObject.objects);
      this.props.canvasRef.handler.canvas.renderAll();
    }
  };

  changeSelectedIconColor = (hex) => {
    const { activeElement, canvasRef } = this.props;
    const activeObject = canvasRef.handler.canvas.getActiveObject();
    if (!activeObject) {
      return;
    }

    const { selectedColor } = this.state;

    let elementFormat = activeElement.format;

    // find and replace color in actual svg element
    let svg = elementFormat.svg;
    let objects = activeObject.getObjects();

    if (activeObject.updateFillMapping) {
      activeObject.updateFillMapping(selectedColor, hex);
    }

    objects.forEach((object, index) => {
      if (object?.orignalFill === selectedColor?.orignalFill) {
        object.set({ fill: hex });
      }
    });

    this.props.canvasRef.handler.set("objects", objects);
    this.props.canvasRef.handler.set("svg", svg);

    // this is to change same selected color multiple times
    this.setState({
      ...this.state,
      selectedColor: {
        orignalFill: this.state.selectedColor.orignalFill,
        replaceFill: hex,
      },
    });
  };
}

IconCommonActions.propTypes = {
  activeElement: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  activeElement: state.editor.activeElement,
  brandKit: state.brandKit,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = {};

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(IconCommonActions)
);
